import { useMemo } from 'react';

import { getSmartCardOptions } from '../utils/smartCardOptions.ts';
import type { ConfluenceEditorCardProvider } from '@confluence/smartlinks';

export const useSmartCards = (
	isChromelessEditor: boolean = false,
): {
	provider: Promise<ConfluenceEditorCardProvider>;
	resolveBeforeMacros: string[];
	allowBlockCards: boolean;
	allowEmbeds: boolean;
} => {
	return useMemo(() => {
		return getSmartCardOptions(isChromelessEditor);
	}, [isChromelessEditor]);
};
